import React from "react";
import { Modal, Typography } from "antd";
import aceCriteriaImage from "../../assets/images/ACE_criteria_image.png";
import aviaCriteriaImage from "../../assets/images/AVIA_criteria_image.png";
import aceCriteriaImage2 from "../../assets/images/ACE_criteria_image2.png";

const { Text } = Typography;

interface EligibilityModalProps {
  visible: boolean;
  onClose: () => void;
  awardName: string;
}

const EligibilityModal: React.FC<EligibilityModalProps> = ({
  visible,
  onClose,
  awardName,
}) => {
  return (
    <Modal
    open={visible}
      onOk={onClose}
      onCancel={onClose}
      width={800} 
    >
      <Text>
        {awardName === "ACE Awards" ? (
          <>
            <img
              src={aceCriteriaImage2}
              alt="ACE Criteria"
              style={{ width: "150%", marginTop: "25px",marginBottom: "0px" }}
            />
            <h4>Criteria</h4>
             <img
              src={aceCriteriaImage}
              alt="ACE Criteria"
              style={{ width: "100%", marginTop: "5px" }}
            />
          </>
          
        ) : awardName === "AVIA Awards" ? (
          <>
            <h4>AVIA AWARDS (Aptean Values in Action)</h4>
            <ul>
              <li>Peer to Peer nominations</li>
              <li>Direct Peer nomination | Behavior/ value demonstrated.</li>
              <li>
                <strong>Category: </strong>
                Aptean Values
              </li>
              <li>
                <strong>Frequency: </strong>Half Yearly
              </li>
              <li>
                <strong>Type: </strong> Individual Award
              </li>
              <li>
                <strong>Value: </strong> $250
              </li>
            </ul>
            <img
              src={aviaCriteriaImage}
              alt="ACE Criteria"
              style={{ width: "100%", marginTop: "20px" }}
            />
          </>
        ) : (
          "Eligibility details not available."
        )}
      </Text>
    </Modal>
  );
};

export default EligibilityModal;
